import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from "react-router"
import envFile from '../assets/studio7Low.hdr'
import { Collapse, Divider, Col, Row, Input, Button, Upload, Switch, Form, notification, Spin, Comment, List, Tooltip, Popconfirm, Typography, Image } from 'antd'
import { InboxOutlined, UploadOutlined, DownloadOutlined, DeleteOutlined, FileImageOutlined, FileOutlined } from '@ant-design/icons'
import {
    createItemVersion,
    updateItemVersion,
    setItem,
    createItemNote,
    deleteItem,
    uploadFileLocker,
    deleteFileLocker,
    getFileLockerRequest,
    createAnnotation,
    setActiveCommentId,
    setHotSpots,
    addHotSpot,
    removeHotSpot,
    selectHotSpotHandler,
    selectHotSpot,
    getItemRequest,
    getCompanyRequest
} from '../features/companies/companiesActions'
import axios from 'axios'
import _ from 'lodash'
import { QR_VIEW_URL, MODEL_SELECT_URL } from '../shared/constants'

var QRCode = require('qrcode.react');
var FormData = require('form-data');

const LOADED_HOTSPOT = 'hotspot-load'
const NEW_HOTSPOT = 'hotspot-new'

const checkElement = async selector => {
    while ( document.querySelector(selector) === null) {
      await new Promise( resolve =>  requestAnimationFrame(resolve) )
    }
    return document.querySelector(selector);
  };

axios.interceptors.response.use(
    res => res,
    err => {
        if (err.response.status === 404) {
            notification.open({message: 'Not Found', description:err.response.data.message})
        } else if (err.response.status === 400) {
            notification.error({message: 'Bad Request', description: err.response.data.message})
        } else if (err.response.status === 401) {
            notification.error({message: 'Authentication Needed', description: `${err.response.data.message}. Try logging in again.`})
        } else if (err.response.status === 403) {
            notification.error({message: 'Bad Authentication', description: `${err.response.data.message}. Try logging in again.`})
        } else if (err.response.status === 409) {
            notification.error({message: 'Conflict', description: err.response.data.message})
        } else {
            console.log(err)
            throw err;
        }
    }
  );

const formLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 24 },
  };


const CommentList = ({ comments,  addHotSpot, removeHotSpot, allHotSpots, selectHotSpotHandler}) => (
    <List
      bordered={true}
      pagination={{pageSize: 2, size: 'small'}}
      dataSource={comments}
      header={`${comments.length} ${comments.length > 1 ? 'comments' : 'comment'}`}
      itemLayout="horizontal"
      renderItem={item => <Comment author={item.user} datetime={item.created} content={item.note} actions={
        [
            <Button onClick={() => {
                for (let hotspot of allHotSpots) {
                    removeHotSpot(hotspot)
                }
                item.annotations.forEach((obj, index) => {
                    addHotSpot(obj, index, selectHotSpotHandler, LOADED_HOTSPOT)
                })

            }}>Show Hotspots</Button>,
            <span style={{marginLeft: 15}}>Item Version: {item.version_number}</span>,
        ]
      }/>}
    />
  );

class ModelInfo extends Component {
    constructor(props) {
        super(props);
        this.loadItem = this.loadItem.bind(this);
        this.loadItem();
    }
    state = {
        loading: false,
        hasGlb: false,
        noteContent: '',
    }

    formRef = React.createRef()
    lockerFormRef = React.createRef()

    loadItem(){
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const itemID = urlParams.get("item");
        const companyID = urlParams.get("company");
        const { token, getItemRequest, getCompanyRequest, getFileLockerRequest } = this.props;

        if (itemID === null || companyID === null) return;

        this.setState({loading: true}, () => {
            const promises = [];

            promises.push(getCompanyRequest(token, companyID));
            promises.push(getItemRequest(token, itemID));
            promises.push(getFileLockerRequest(token, itemID));

            Promise.all(promises).then(() => {
                this.setState({loading: false});
            });
        });
    }
    checkAndOpenURL(url) {
        fetch(url)
            .then((response) => {
                if(!response.ok) {
                    notification.error({message: 'Not Found', description: 'The file is not found'});
                } else {
                    window.open(url, "_blank");
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
    }

    componentDidMount() {
        const modelViewer = document.getElementById('threeDModel');
        const { addHotSpot, selectHotSpotHandler, setHotSpots, companies } = this.props
        setHotSpots([])
        if (! _.isNil(companies) && ! _.isNil(companies.itemData) && ! _.isNil(companies.itemData.notes) && ! _.isEmpty(companies.itemData.notes) && ! _.isNil(companies.itemData.notes[0].annotations)) {

            companies.itemData.notes[0].annotations.forEach((obj, index) => {
                addHotSpot(obj, index, selectHotSpotHandler, LOADED_HOTSPOT)
            })
        }

        this.loadItem();

        const tapDistance = 2;
        let panning = false;
        let panX, panY;
        let startX, startY;
        let lastX, lastY;
        let metersPerPixel;

        const startPan = () => {
            const orbit = modelViewer.getCameraOrbit();
            const {theta, phi, radius} = orbit;
            metersPerPixel = 0.75 * radius / modelViewer.getBoundingClientRect().height;
            panX = [-Math.cos(theta), 0, Math.sin(theta)];
            panY = [
                -Math.cos(phi) * Math.sin(theta),
                Math.sin(phi),
                -Math.cos(phi) * Math.cos(theta)
            ];
            modelViewer.interactionPrompt = 'none';
        };

        const movePan = (thisX, thisY) => {
            const dx = (thisX - lastX) * metersPerPixel;
            const dy = (thisY - lastY) * metersPerPixel;
            lastX = thisX;
            lastY = thisY;

            const target = modelViewer.getCameraTarget();
            target.x += dx * panX[0] + dy * panY[0];
            target.y += dx * panX[1] + dy * panY[1];
            target.z += dx * panX[2] + dy * panY[2];
            modelViewer.cameraTarget = `${target.x}m ${target.y}m ${target.z}m`;
        };

        const recenter = (pointer) => {
            panning = false;
            if (Math.abs(pointer.clientX - startX) > tapDistance ||
                Math.abs(pointer.clientY - startY) > tapDistance)
                return;
            const rect = modelViewer.getBoundingClientRect();
            const x = pointer.clientX - rect.left;
            const y = pointer.clientY - rect.top;
            const hit = modelViewer.positionAndNormalFromPoint(x, y);
            modelViewer.cameraTarget =
                hit == null ? 'auto auto auto' : hit.position.toString();
        };

        if (! _.isNil(modelViewer)) {
            modelViewer.addEventListener('mousedown', (event) => {
                startX = event.clientX;
                startY = event.clientY;
                panning = event.button === 2 || event.ctrlKey || event.metaKey ||
                    event.shiftKey;
                if (!panning)
                    return;

                lastX = startX;
                lastY = startY;
                startPan();
                event.stopPropagation();
            }, true);

            modelViewer.addEventListener('touchstart', (event) => {
                startX = event.touches[0].clientX;
                startY = event.touches[0].clientY;
                panning = event.touches.length === 2;
                if (!panning)
                    return;

                const {touches} = event;
                lastX = 0.5 * (touches[0].clientX + touches[1].clientX);
                lastY = 0.5 * (touches[0].clientY + touches[1].clientY);
                startPan();
            }, true);

            modelViewer.addEventListener('mousemove', (event) => {
                if (!panning)
                    return;

                movePan(event.clientX, event.clientY);
                event.stopPropagation();
            }, true);

            modelViewer.addEventListener('touchmove', (event) => {
                if (!panning || event.touches.length !== 2)
                    return;

                const {touches} = event;
                const thisX = 0.5 * (touches[0].clientX + touches[1].clientX);
                const thisY = 0.5 * (touches[0].clientY + touches[1].clientY);
                movePan(thisX, thisY);
            }, true);

            modelViewer.addEventListener('mouseup', (event) => {
                recenter(event);
            }, true);

            modelViewer.addEventListener('touchend', (event) => {
                if (event.touches.length === 0) {
                    recenter(event.changedTouches[0]);
                }
            }, true);
        }
    }

    addNewHotspot = () => {
        const viewer = document.getElementById('threeDModel');
        viewer.addEventListener('click', this.onModelAnnotationClick);
    }

    removeNewHotspot = () => {
        const { removeHotSpot, selectHotSpot } = this.props
        let selected = document.getElementsByClassName('selected')

        if (! _.isEmpty(selected) && selected[0].classList.contains(NEW_HOTSPOT)) {
            removeHotSpot(selected[0])
            selectHotSpot(null)
        }
    }

    onModelAnnotationClick = (event) => {
        const viewer = document.getElementById('threeDModel');
        const rect = viewer.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        const positionAndNormal = viewer.positionAndNormalFromPoint(x, y);

        if (positionAndNormal == null) {
            notification.warning({message:'Invalid Location', description: 'Please click on the model itself to add a hotspot'} );
            return;
        }
        const { position, normal } = positionAndNormal;

        let hotspot = {}
        hotspot.pX = position.x
        hotspot.pY = position.y
        hotspot.pZ = position.z

        if (normal != null) {
            hotspot.nX = normal.x
            hotspot.nY = normal.y
            hotspot.nZ = normal.z
        } else {
            hotspot.nX = null
            hotspot.nY = null
            hotspot.nZ = null
        }

        const { addHotSpot, selectHotSpotHandler, companies, removeHotSpot } = this.props

        for (let hotspot of companies.allHotSpots) {
            if (hotspot.classList.contains(LOADED_HOTSPOT)) {
                removeHotSpot(hotspot)
            }
        }
        addHotSpot(hotspot, _.filter(companies.allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)).length + 1, selectHotSpotHandler, NEW_HOTSPOT)

        viewer.removeEventListener('click', this.onModelAnnotationClick);
    }

    onLockerFormFailed = () => {
        console.log('Bad input!')
    }

    onLockerFormFinish = () => {
        const { token, uploadFileLocker, companies, getFileLockerRequest } = this.props
        const { itemData } = companies
        const data = this.lockerFormRef.current.getFieldsValue()

        let productImages = []
        let referenceFiles = []

        if (data.product_image) {
            productImages = data.product_image.fileList
        }
        if (data.reference_file) {
            referenceFiles = data.reference_file.fileList
        }
        if (productImages.length || referenceFiles.length) {
            this.setState({loading: true}, () => {
                let promises = []
                productImages.forEach( productImage => {
                    promises.push(uploadFileLocker(token, itemData.id, productImage.originFileObj, 'product_image', productImage.name))
                })
                referenceFiles.forEach( referenceFile => {
                    promises.push(uploadFileLocker(token, itemData.id, referenceFile.originFileObj, 'reference_file', referenceFile.name))
                })

                Promise.all(promises).then(() => {
                    getFileLockerRequest(token, itemData.id).then(()=> {
                        this.setState({loading: false})
                    })

                })
            })
        } else {
            notification.error({
                message: 'Bad Input',
                description:
                'Must include either a product image or reference file!',
              })
        }
    }

    onFormFailed = () => {
        console.log('Bad input!')
    }

    onFormFinish = () => {
        const {
            token,
            createItemVersion,
            updateItemVersion,
            createItemNote,
            user,
            companies,
            createAnnotation,
            addHotSpot,
            getItemRequest,
            selectHotSpotHandler,
            removeHotSpot,
        } = this.props

        const { itemData, allHotSpots } = companies
        const { post_url } = itemData
        const data = this.formRef.current.getFieldsValue()

        if (this.getSubmitDisabled()) {
            notification.error({
            message: 'Bad Input',
            description:
            'Must include a comment!',
          })
        } else {
            if (user.admin) {
                if (data.glb) {
                    const { glb } = post_url
                    const glbFormData = new FormData()

                    Object.keys(glb.fields).forEach(key => {
                        glbFormData.append(key, glb.fields[key]);
                    });

                    glbFormData.append("file", data.glb.file);

                    if (itemData.current_status !== 'Created') {
                        createItemVersion(token, {item_id: itemData.id}).then( versionResp => {
                            if (data.notes) {
                                createItemNote(token, {note: data.notes, item_version_id: versionResp.id}).then( (resp) => {
                                    let annotationPromises = []
                                    if ( _.some(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)) ) {
                                        _.filter(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)).forEach( (hotspot) => {
                                            const [pX, pY, pZ] = hotspot.dataset.position.split(' ')
                                            const [nX, nY, nZ] = hotspot.dataset.normal.split(' ')
                                            annotationPromises.push(createAnnotation(token, {pX, pY, pZ, nX, nY, nZ, item_note_id: resp.id, item_id: itemData.id}))
                                        })
                                    }
                                    Promise.all(annotationPromises).then( () => {
                                        this.setState({loading: false, noteContent: '',}, () => {
                                            checkElement('#threeDModel').then(()=> {
                                                getItemRequest(token, itemData.id).then(resp => {
                                                    resp.notes[0].annotations.forEach((obj, index) => {
                                                        addHotSpot(obj, index, selectHotSpotHandler, LOADED_HOTSPOT)
                                                    })
                                                    _.filter(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)).forEach(hotspot => {
                                                        removeHotSpot(hotspot)
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })                            }
                        })
                    } else {
                        const { current_version_id } = itemData
                        updateItemVersion(token, current_version_id, { item_id: itemData.id, status_id: this.getStatusId('Client Review')})

                        if (data.notes) {
                            createItemNote(token, {note: data.notes, item_version_id: current_version_id}).then( (resp) => {
                                let annotationPromises = []
                                if ( _.some(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)) ) {
                                    _.filter(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)).forEach( (hotspot) => {
                                        const [pX, pY, pZ] = hotspot.dataset.position.split(' ')
                                        const [nX, nY, nZ] = hotspot.dataset.normal.split(' ')
                                        annotationPromises.push(createAnnotation(token, {pX, pY, pZ, nX, nY, nZ, item_note_id: resp.id, item_id: itemData.id}))
                                    })
                                }
                                Promise.all(annotationPromises).then( () => {
                                    this.setState({loading: false, noteContent: '',}, () => {
                                        checkElement('#threeDModel').then(()=> {
                                            getItemRequest(token, itemData.id).then(resp => {
                                                resp.notes[0].annotations.forEach((obj, index) => {
                                                    addHotSpot(obj, index, selectHotSpotHandler, LOADED_HOTSPOT)
                                                })
                                                _.filter(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)).forEach(hotspot => {
                                                    removeHotSpot(hotspot)
                                                })
                                            })
                                        })
                                    })
                                })
                            })                        }
                    }
                    this.setState({loading: true}, () => {
                        const createInS3 = [
                            axios({
                                method: 'post',
                                url: glb.url,
                                data: glbFormData,
                                headers: {'Content-Type': 'multipart/form-data' }
                            }),
                        ]

                        Promise.all(createInS3).then(() => {
                            this.setState({loading: false, noteContent: '',})
                        })
                    })
                } else {
                    if (data.notes) {
                        const { current_version_id } = itemData
                        this.setState({loading: true})
                        createItemNote(token, {note: data.notes, item_version_id: current_version_id}).then( (resp) => {
                            let annotationPromises = []
                            if ( _.some(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)) ) {
                                _.filter(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)).forEach( (hotspot) => {
                                    const [pX, pY, pZ] = hotspot.dataset.position.split(' ')
                                    const [nX, nY, nZ] = hotspot.dataset.normal.split(' ')
                                    annotationPromises.push(createAnnotation(token, {pX, pY, pZ, nX, nY, nZ, item_note_id: resp.id, item_id: itemData.id}))
                                })
                            }
                            Promise.all(annotationPromises).then( () => {
                                this.setState({loading: false, noteContent: '',}, () => {
                                    checkElement('#threeDModel').then(()=> {
                                        getItemRequest(token, itemData.id).then(resp => {
                                            resp.notes[0].annotations.forEach((obj, index) => {
                                                addHotSpot(obj, index, selectHotSpotHandler, LOADED_HOTSPOT)
                                            })
                                            _.filter(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)).forEach(hotspot => {
                                                removeHotSpot(hotspot)
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    }
                }
            } else {
                const { current_version_id, id, current_status_id } = itemData

                this.setState({loading: true}, () => {
                    updateItemVersion(token, current_version_id, { item_id: id, status_id: this.getStatusId(current_status_id === 4 ? 'Finalized' : 'Bitreel Review')}
                    ).then(() => {
                        createItemNote(token, {note: data.notes, item_version_id: current_version_id}).then( (resp) => {
                            let annotationPromises = []
                            if ( _.some(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)) ) {
                                _.filter(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)).forEach( (hotspot) => {
                                    const [pX, pY, pZ] = hotspot.dataset.position.split(' ')
                                    const [nX, nY, nZ] = hotspot.dataset.normal.split(' ')
                                    annotationPromises.push(createAnnotation(token, {pX, pY, pZ, nX, nY, nZ, item_note_id: resp.id, item_id: itemData.id}))
                                })
                            }
                            Promise.all(annotationPromises).then( () => {
                                this.setState({loading: false, noteContent: '',}, () => {
                                    checkElement('#threeDModel').then(()=> {
                                        getItemRequest(token, itemData.id).then(resp => {
                                            resp.notes[0].annotations.forEach((obj, index) => {
                                                addHotSpot(obj, index, selectHotSpotHandler, LOADED_HOTSPOT)
                                            })
                                            _.filter(allHotSpots, obj => obj.classList.contains(NEW_HOTSPOT)).forEach(hotspot => {
                                                removeHotSpot(hotspot)
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                    })
            }
        }
    }

    getStatusId(approvalText) {
        const { companies } = this.props
        const { itemStatuses } = companies
        return _.filter(Object.values(itemStatuses), obj => {
            return obj['name'] === approvalText
        })[0].id
    }

    getSubmitDisabled() {
        const { user, } = this.props
        const { noteContent, hasGlb } = this.state
        return (user.admin ? (! hasGlb && ! noteContent) : ! noteContent)
    }

    modelApprovalUpdate(checked, event) {
        const { current_version_id, id } = this.props.companies.itemData;
        this.props.updateItemVersion(this.props.token, current_version_id, {
            item_id: id,
            status_id: this.getStatusId(checked ? "Finalized" : "Bitreel Review"),
        });
    }

    toggleFullscreen() {
        const modelElement = document.getElementById('threeDModel');
        if(modelElement.getAttribute("expanded") == "true") {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) { /* Firefox */
            document.mozCancelFullScreen();
          } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
            document.webkitExitFullscreen();
          } else if (document.msExitFullscreen) { /* IE/Edge */
            document.msExitFullscreen();
          }
        } else {
          if (modelElement.requestFullscreen) {
            modelElement.requestFullscreen();
          } else if (modelElement.mozRequestFullScreen) { /* Firefox */
            modelElement.mozRequestFullScreen();
          } else if (modelElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
            modelElement.webkitRequestFullscreen();
          } else if (modelElement.msRequestFullscreen) { /* IE/Edge */
            modelElement.msRequestFullscreen();
          }
        }
      }

    render() {
        const { loading, noteContent, hasGlb } = this.state
        const { companies, user, token, deleteItem, history, deleteFileLocker, selectHotSpotHandler, addHotSpot, removeHotSpot } = this.props
        const { itemData, orderData, companyDetail, fileLockerData, allHotSpots } = companies
        const { Panel } = Collapse
        const { Title, Text } = Typography
        if (loading) {
            return <Spin />
        }

        if(
            itemData && companyDetail &&
            user != null && user.admin != null
            ) {

            const { get_url, name, price, description, current_status, current_version, order_id, notes, product_url } = itemData
            let product_image = []
            let reference_file = []

            if (fileLockerData) {
                product_image = fileLockerData.product_image
                reference_file = fileLockerData.reference_file
            }

            const { project_id } = orderData
            const { TextArea } = Input
            const { Dragger } = Upload

            return <>
            <Row style={{marginBottom: 20}}>
                { itemData.current_status === 'Created'
                    ? <Title level={1}>Model In Progress: {`${name}`}</Title>
                    :
                    <>
                        <Title level={1}>Item Information: {`${name}`}</Title>
                        <model-viewer onContextMenu={(e)=>e.preventDefault()} id='threeDModel' style={{width: '100%', height: '45vh'}} src={get_url.glb} alt="A 3D model" auto-rotate camera-controls autoplay environment-image={envFile}/>
                        <Col span={24} style={{display: 'flex', justifyContent: 'center'}}>
                            <Text type='secondary'>ITEM PREVIEW ONLY - not final quality</Text>
                        </Col>
                        <Col >
                            <Button id="expand-button" className="expandBtn" onClick={() => {this.toggleFullscreen()}} style={{float:'right'}}>
                                View Fullscreen
                            </Button>
                            <Button className="hide-hotspots-button" onClick={() => {
                                    for (let hotspot of allHotSpots) {
                                        removeHotSpot(hotspot)
                                    }
                                }} style={{float:'right'}}>
                                Hide Hotspots
                            </Button>
                        </Col>
                    </>

                }
            </Row>
                <Row align='middle' justify='center' style={{marginBottom: 10}}>
                    <Switch
                        onChange={(checked, event) =>
                            this.modelApprovalUpdate(checked, event)
                        }
                        defaultChecked={
                            this.props.companies.itemData.current_status === "Finalized"
                        }
                        disabled={itemData.current_status === 'Created'}
                        checkedChildren="Approved"
                        unCheckedChildren="Needs Work" />
                </Row>
                <Row >
                <Col span={4}>
                    <Collapse>
                        <Panel header={'Details'} key="1">
                            <p><span style={{fontWeight: 600}}>Status: </span>{current_status}</p>
                            <Divider type='horizontal' />
                            <p><span style={{fontWeight: 600}}>Current Version Number: </span>{current_version}</p>
                            <Divider type='horizontal' />
                            <p><span style={{fontWeight: 600}}>Price: </span>{price}</p>
                            <Divider type='horizontal' />
                            <p><span style={{fontWeight: 600}}>Description: </span>{description}</p>
                            <Divider type='horizontal' />
                            <p><span style={{fontWeight: 600}}>Product URL: </span>{product_url}</p>
                            <div style={user.admin ? {} : {display: 'none'}}>
                            <Divider type='horizontal' />
                            <p><span style={{fontWeight: 600}}>Company ID: </span>{companyDetail.id}</p>
                            <Divider type='horizontal' />
                            <p><span style={{fontWeight: 600}}>Project ID: </span>{project_id}</p>
                            <Divider type='horizontal' />
                            <p><span style={{fontWeight: 600}}>Order ID: </span>{order_id}</p>
                            <Divider type='horizontal' />
                            <p><span style={{fontWeight: 600}}>Item ID: </span>{itemData.id}</p>
                            </div>
                        </Panel>
                    </Collapse>
                </Col>
                <Col span={19} offset={1}>

                    <Form
                        {...formLayout}
                        name="item"
                        onFinish={this.onFormFinish}
                        onFinishFailed={this.onFormFailed}
                        ref={this.formRef}
                    >
                        <Row style={{marginBottom: 20}}>
                            <Col span={18}>
                                <CommentList comments={notes} selectHotSpotHandler={selectHotSpotHandler} addHotSpot={addHotSpot} removeHotSpot={removeHotSpot} allHotSpots={allHotSpots}/>
                                <div className='hotspot-buttons'>
                                    <Button className='addButton' onClick={() => {this.addNewHotspot()}}>
                                        Add Hotspot
                                    </Button>
                                    <Button className='removeButton' onClick={() => {this.removeNewHotspot()}}>
                                        Remove Hotspot
                                    </Button>
                                </div>
                                <Form.Item
                                    name="notes"
                                    rules={[{ required: ! user.admin, message: 'Please add note' }]}
                                >
                                    <TextArea placeholder="Enter note here" style={{ width: '100%', marginTop: 5 }} rows={3}
                                        value={noteContent} onChange={
                                            (e) => this.setState({noteContent: e.target.value})
                                    }/>
                                </Form.Item>
                                <Row align='middle' justify='space-around' style={user.admin ? {marginBottom: 5} : {display: 'none'}}>
                                    <Button  icon={<DownloadOutlined />} type='primary' onClick={ () => {
                                        const url = get_url.glb;
                                        this.checkAndOpenURL(url);
                                    }
                                    }
                                        >Download GLB</Button>
                                    <Button  icon={<DownloadOutlined />} type='primary' onClick={ () => {
                                        const url = get_url.usdz;
                                        this.checkAndOpenURL(url);
                                    }}
                                        >Download USDZ</Button>
                                </Row>
                                <Row style={! user.admin ? {marginBottom: 5} : {display: 'none'}}>
                                    <Col offset={9}>
                                        <p>View in your space:</p>
                                        <QRCode value={`${window.location.origin}${QR_VIEW_URL}?usdzModel=${encodeURIComponent(get_url.usdz)}&glbModel=${encodeURIComponent(get_url.glb)}&showAR=true`} />
                                    </Col>
                                </Row>

                            </Col>
                        </Row>

                        <Row align='middle' justify='space-between'>
                                <Col offset={1} span={12} style={! user.admin ? {display: 'none'} : {}}>
                                    <Form.Item
                                        label="GLB"
                                        name="glb"
                                        rules={[{ required: user.admin, message: 'Please upload GLB model' }]}
                                        valuePropName="file"
                                    >
                                    <Dragger name='file' multiple={false}  accept=".glb"
                                        beforeUpload={file => {
                                            this.setState({hasGlb: true})
                                            return false
                                    }}>
                                        <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Click or drag .glb file to this area to upload</p>
                                    </Dragger>
                                    </Form.Item>
                                </Col>
                                <Col offset={7} span={12}>
                                    <Tooltip title={(user.admin && (! hasGlb && ! noteContent) ? 'Must include glb or note.' : ! user.admin && ! noteContent ? 'Must include comment.' : '')}>
                                        <Button disabled={this.getSubmitDisabled()} icon={<UploadOutlined />} type='primary' onClick={this.onFormFinish}>Submit</Button>
                                    </Tooltip>
                                    <Popconfirm title="Are you sure?" onConfirm={() => {
                                        deleteItem(token, itemData.id)
                                        history.push(MODEL_SELECT_URL)
                                    }
                                    }>
                                        <Button style={user.admin ? {marginLeft: 5} : {display: 'none'}} type='primary' danger={true} icon={<DeleteOutlined />}>Delete</Button>
                                    </Popconfirm>
                                </Col>
                        </Row>
                        <Row align='middle' style={{marginTop: 20}}>
                            <Col span={8}>
                                <Title level={5}>Product Images</Title>
                                <List
                                    bordered={true}
                                    pagination={{pageSize: 5, size: 'small'}}
                                    dataSource={product_image}
                                    header={`${product_image.length} ${product_image.length > 1 ? 'images' : 'image'}`}
                                    itemLayout="horizontal"
                                    renderItem={item =>
                                    <List.Item
                                        actions={[
                                        <Popconfirm title="Are you sure?" onConfirm={() => {
                                            deleteFileLocker(token, itemData.id, 'product_image', item.file_name)
                                        }
                                        }>
                                            <Button danger={true} size='small' type='primary' shape='circle' icon={<DeleteOutlined />} />
                                        </Popconfirm>
                                    ]}
                                    >
                                        <List.Item.Meta
                                            avatar={<Image
                                                width={120}
                                                src={item.url}
                                                fallback="data:image/png;base64,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"
                                            />}
                                            title={<a href={item.url}>{item.file_name}</a>}
                                        />
                                    </List.Item>
                                }
                                />
                            </Col>
                            <Col span={8} offset={2}>
                                <Title level={5}>3D Reference Files</Title>
                                <List
                                    bordered={true}
                                    pagination={{pageSize: 5, size: 'small'}}
                                    dataSource={reference_file}
                                    header={`${reference_file.length} ${reference_file.length > 1 ? 'files' : 'file'}`}
                                    itemLayout="horizontal"
                                    renderItem={item =>
                                    <List.Item
                                        actions={[
                                        <Popconfirm title="Are you sure?" onConfirm={() => {
                                            deleteFileLocker(token, itemData.id, 'reference_file', item.file_name)
                                        }
                                        }>
                                            <Button danger={true} size='small' type='primary' shape='circle' icon={<DeleteOutlined />} />
                                        </Popconfirm>
                                    ]}
                                    >
                                        <List.Item.Meta
                                            avatar={<FileOutlined />}
                                            title={<a href={item.url}>{item.file_name}</a>}
                                        />
                                    </List.Item>
                                }
                                />
                            </Col>
                        </Row>
                        </Form>
                        <Form
                                name="file_locker"
                                onFinish={this.onLockerFormFinish}
                                onFinishFailed={this.onLockerFormFailed}
                                ref={this.lockerFormRef}
                            >
                            <Row style={{marginTop: 20}} >
                                <Col span={8}>
                                    <Form.Item
                                        label="Product Images"
                                        name="product_image"
                                        rules={[{ required: false, message: 'Please upload any additional product images' }]}
                                        valuePropName="file"
                                    >
                                        <Dragger name='file' multiple={true}
                                            beforeUpload={file => {
                                            return false
                                        }}>
                                            <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                            </p>
                                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                            <p className="ant-upload-hint">
                                            Support for a single or bulk upload.
                                            </p>
                                        </Dragger>
                                    </Form.Item>
                                </Col>
                                <Col span={8} offset={2}>
                                    <Form.Item
                                        label="Reference Files"
                                        name="reference_file"
                                        rules={[{ required: false, message: 'Please upload any 3D reference files' }]}
                                        valuePropName="file"
                                    >
                                        <Dragger name='file' multiple={true}
                                            beforeUpload={file => {
                                            return false
                                        }}>
                                            <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                            </p>
                                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                            <p className="ant-upload-hint">
                                            Support for a single or bulk upload.
                                            </p>
                                        </Dragger>
                                    </Form.Item>
                                </Col>
                            </Row>
                        <Row>
                            <Col offset={14}>
                            <Button type='primary' icon={<UploadOutlined />}onClick={()=> {this.onLockerFormFinish()}}>Upload File Locker</Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
             </Row>
            </>
        } else {
            return <>
            </>
        }
    }
}

const mapStateToProps = ({ companies }) => {
    return {
        companies
    }
}

export default connect (mapStateToProps, {
    createItemVersion,
    updateItemVersion,
    setItem,
    createItemNote,
    deleteItem,
    uploadFileLocker,
    deleteFileLocker,
    getFileLockerRequest,
    createAnnotation,
    setActiveCommentId,
    setHotSpots,
    addHotSpot,
    removeHotSpot,
    selectHotSpotHandler,
    selectHotSpot,
    getItemRequest,
    getCompanyRequest
}) (withRouter(ModelInfo))
